import { render, staticRenderFns } from "./FavoriteSidebarTab.vue?vue&type=template&id=ed53895c&scoped=true"
import script from "./FavoriteSidebarTab.vue?vue&type=script&lang=js"
export * from "./FavoriteSidebarTab.vue?vue&type=script&lang=js"
import style0 from "./FavoriteSidebarTab.vue?vue&type=style&index=0&id=ed53895c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed53895c",
  null
  
)

export default component.exports